import { 
  Crown, Cat, Star, Heart, Rocket, Shield, Dog, Bird, Fish, Flame, 
  Zap, Coffee, Music, Gamepad2, Trophy, Diamond, Gift, Sparkles 
} from 'lucide-react';
import { cn } from '../../lib/utils';

// Icon mapping for profile
export const PROFILE_ICONS = {
  crown: { icon: Crown, color: 'text-yellow-400' },
  cat: { icon: Cat, color: 'text-orange-400' },
  star: { icon: Star, color: 'text-yellow-300' },
  heart: { icon: Heart, color: 'text-pink-400' },
  rocket: { icon: Rocket, color: 'text-blue-400' },
  shield: { icon: Shield, color: 'text-cyan-400' },
  dog: { icon: Dog, color: 'text-amber-400' },
  bird: { icon: Bird, color: 'text-sky-400' },
  fish: { icon: Fish, color: 'text-teal-400' },
  flame: { icon: Flame, color: 'text-orange-500' },
  zap: { icon: Zap, color: 'text-yellow-400' },
  coffee: { icon: Coffee, color: 'text-amber-600' },
  music: { icon: Music, color: 'text-purple-400' },
  gamepad: { icon: Gamepad2, color: 'text-green-400' },
  trophy: { icon: Trophy, color: 'text-yellow-500' },
  diamond: { icon: Diamond, color: 'text-cyan-300' },
  gift: { icon: Gift, color: 'text-red-400' },
  sparkles: { icon: Sparkles, color: 'text-purple-300' },
};

export function Avatar({ user, size = 'md' }) {
  const sizeClasses = {
    sm: 'w-8 h-8 text-xs',
    md: 'w-10 h-10 text-sm',
    lg: 'w-12 h-12 text-base'
  };
  const iconSizes = { sm: 14, md: 18, lg: 22 };
  
  const profileIcon = user?.profile_icon;
  
  if (profileIcon && PROFILE_ICONS[profileIcon]) {
    const IconComponent = PROFILE_ICONS[profileIcon].icon;
    const iconColor = PROFILE_ICONS[profileIcon].color;
    return (
      <div className={cn(
        'rounded-xl bg-gradient-to-br from-red-500 to-red-600 flex items-center justify-center flex-shrink-0',
        sizeClasses[size]
      )}>
        <IconComponent size={iconSizes[size]} className={iconColor} />
      </div>
    );
  }
  
  return (
    <div className={cn(
      'rounded-xl bg-gradient-to-br from-red-500 to-red-600 flex items-center justify-center font-bold text-white flex-shrink-0',
      sizeClasses[size]
    )}>
      {user?.prenom?.[0]}{user?.nom?.[0]}
    </div>
  );
}
